import ForgotPassword from '@/app/forgot-password/ForgotPassword'
import { createFileRoute } from '@tanstack/react-router'


const RouteComponent = () => {
  return <ForgotPassword />
}

export const Route = createFileRoute('/_unauth/forgot-password')({
  component: RouteComponent,
})


